define([
	"dojo/_base/lang",
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/def/ViewRef",
	"csi/xml"
], function(lang,def,Action,ActionFactory,ViewRef,xml) {

	return ActionFactory.declare("Edit", Action, {
		constructor: function(obj) {
			this.m_tag = this.m_tag || "Edit";

			if (!this.m_typeControl) {
				this.setMaterialIcon('mode_edit');
			}

			this.m_viewRef = this.m_viewRef || lang.mixin(new ViewRef(), {m_id: def.DEFAULT_FORM_ID});
			this.setBaseRights(xml.RIGHT_WRITE);
		}
	});
});